export default __webpack_public_path__ + "static/media/3.b7a97602.jpg";